import { DateFormat, NumberFormat, Trans } from '@lingui/macro'
import { colors, Paper } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import React from 'react'
import styled from 'react-emotion/macro'
import { IStats, paths } from 'shopify-payment-core'

import { useFirebaseQuery } from '../hooks/useFirebaseQuery'

interface IProps {}

const StatsToRight = styled(Paper)`
  display: flex;
  justify-content: space-between;
  margin: 0.5rem;
  padding: 0.5rem;
`

const ValueDisplay = styled.div`
  & span {
    font-size: 0.8rem;
    color: ${colors.grey[500]};
  }
`

const dateFormat: Intl.DateTimeFormatOptions = {
  day: 'numeric',
  weekday: 'long',
  month: 'long',
  hour12: false,
  hour: '2-digit',
  minute: '2-digit',
}

export const DashboardStats = observer<IProps>(() => {
  const { data, loading } = useFirebaseQuery<IStats>(paths.gopay.stats, {
    subscribe: true,
  })
  if (loading) {
    return null
  }
  const stats = data!
  return (
    <StatsToRight>
      <ValueDisplay>
        <span>
          <Trans>Poslední úspěšná platba</Trans>
        </span>
        <div>
          <DateFormat value={new Date(stats.lastPayment)} format={dateFormat} />
        </div>
      </ValueDisplay>
      <ValueDisplay>
        <span>
          <Trans>Celkem zaplaceno</Trans>
        </span>
        <div>
          {`$ `}
          <NumberFormat value={stats.totalAmount} />
        </div>
      </ValueDisplay>
      <ValueDisplay>
        <span>
          <Trans>Plateb celkem</Trans>
        </span>
        <div>
          <NumberFormat value={stats.paymentCount} />
        </div>
      </ValueDisplay>
    </StatsToRight>
  )
})
